(function () {
  document.documentElement.classList.add('bambi-js');

  function normalizeHeading(value) {
    return (value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[•·⋅˚₊‧୨୧ꔫ♡♥✧✦✨]/g, ' ')
      .replace(/[\u2010\u2011\u2012\u2013\u2014\u2212]/g, '-')
      .replace(/[“”"']/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/[.:;\-–—|…]+$/, '')
      .trim()
      .toUpperCase();
  }

  function sectionForHeading(value) {
    var heading = normalizeHeading(value);
    if (!heading || heading.length > 70) return null;

    if (/^DESCRIPTION$/.test(heading)) {
      return 'description';
    }

    if (/^(DETAILS|PRODUCT DETAILS|PRODUCT DETAIL|PRODUCT DESCRIPTION)$/.test(heading)) {
      return 'details';
    }

    if (/^(SIZING|SIZE CHART|SIZE GUIDE|SIZING GUIDE|SIZING & FIT|SIZING AND FIT|SIZING \+ FIT|SIZE & FIT|SIZE AND FIT|SIZE \+ FIT|FIT & SIZING|FIT AND SIZING)$/.test(heading)) {
      return 'size';
    }

    if (/^(FABRIC DETAILS & CARE|FABRIC DETAILS AND CARE|FABRIC DETAILS \+ CARE|FABRIC & CARE|FABRIC AND CARE|FABRIC \+ CARE|MATERIALS & CARE|MATERIALS AND CARE|MATERIAL & CARE|MATERIAL AND CARE|COMPOSITION & CARE|COMPOSITION AND CARE|CARE INSTRUCTIONS|FABRIC DETAILS|FABRIC|CARE)$/.test(heading)) {
      return 'fabric';
    }

    if (/^(PRE-ORDER|PRE ORDER|PREORDER|PRE-ORDERS|PRE ORDERS|PREORDERS|PRE-ORDER DETAILS|PRE ORDER DETAILS|PREORDER DETAILS|PRE-ORDER INFORMATION|PRE ORDER INFORMATION|PREORDER INFORMATION|PRE-ORDER INFO|PRE ORDER INFO|PREORDER INFO)$/.test(heading)) {
      return 'preorder';
    }

    if (/^(SHIPPING \+ RETURNS|SHIPPING & RETURNS|SHIPPING AND RETURNS|SHIPPING \/ RETURNS|SHIPPING & RETURN|DELIVERY \+ RETURNS|DELIVERY & RETURNS|DELIVERY AND RETURNS|RETURNS & SHIPPING|RETURNS AND SHIPPING)$/.test(heading)) {
      return 'shipping';
    }

    if (/^(WEAR IT WITH|WEAR WITH|STYLE IT WITH|PAIR IT WITH)$/.test(heading)) {
      return 'wear';
    }

    return null;
  }

  function exactElementHeadingSection(node) {
    if (!node || node.nodeType !== 1) return null;

    var tag = (node.tagName || '').toUpperCase();
    var headingLikeTag = /^(H1|H2|H3|H4|H5|H6|STRONG|B|EM|SPAN|P|DIV)$/.test(tag);
    if (!headingLikeTag) return null;

    return sectionForHeading(node.textContent);
  }

  function textNodeContainsHeading(node) {
    if (!node || node.nodeType !== 3) return false;
    var pieces = (node.nodeValue || '').split(/\r?\n/);
    for (var i = 0; i < pieces.length; i += 1) {
      if (sectionForHeading(pieces[i])) return true;
    }
    return false;
  }

  function subtreeContainsHeading(node) {
    if (!node) return false;
    if (node.nodeType === 3) return textNodeContainsHeading(node);
    if (node.nodeType !== 1) return false;
    if (exactElementHeadingSection(node)) return true;

    for (var i = 0; i < node.childNodes.length; i += 1) {
      if (subtreeContainsHeading(node.childNodes[i])) return true;
    }
    return false;
  }

  function appendTextWithHeadingDetection(node, buckets, current) {
    var raw = node.nodeValue || '';
    var lines = raw.split(/(\r?\n)/);

    for (var i = 0; i < lines.length; i += 1) {
      var part = lines[i];
      if (!part) continue;

      if (/^\r?\n$/.test(part)) {
        buckets[current].appendChild(document.createTextNode(part));
        continue;
      }

      var next = sectionForHeading(part);
      if (next) {
        current = next;
      } else {
        buckets[current].appendChild(document.createTextNode(part));
      }
    }

    return current;
  }

  function distributeNode(node, buckets, current) {
    if (!node) return current;

    if (node.nodeType === 3) {
      return appendTextWithHeadingDetection(node, buckets, current);
    }

    if (node.nodeType !== 1) return current;

    var directHeading = exactElementHeadingSection(node);
    if (directHeading) return directHeading;

    // Shopify's rich-text editor frequently nests a heading inside a paragraph,
    // e.g. <p><strong>DETAILS</strong><br>...</p>. Walk into such blocks so the
    // text after the nested heading lands in the correct destination.
    if (subtreeContainsHeading(node)) {
      for (var i = 0; i < node.childNodes.length; i += 1) {
        current = distributeNode(node.childNodes[i], buckets, current);
      }
      return current;
    }

    // A bullet list immediately after the visible story copy is almost always
    // the product-details list even on older listings without a DETAILS heading.
    if (current === 'editorial' && /^(UL|OL)$/.test(node.tagName || '')) {
      buckets.details.appendChild(node.cloneNode(true));
      return 'details';
    }

    buckets[current].appendChild(node.cloneNode(true));
    return current;
  }

  function trimBucket(bucket) {
    if (!bucket) return;

    function isDisposable(node) {
      if (!node) return false;
      if (node.nodeType === 3) return !node.textContent.trim();
      return node.nodeType === 1 && node.tagName === 'BR';
    }

    while (bucket.firstChild && isDisposable(bucket.firstChild)) {
      bucket.removeChild(bucket.firstChild);
    }
    while (bucket.lastChild && isDisposable(bucket.lastChild)) {
      bucket.removeChild(bucket.lastChild);
    }
  }

  function fragmentHasContent(fragment) {
    if (!fragment) return false;
    return normalizeHeading(fragment.textContent).length > 0 || !!fragment.querySelector('img, table, video, iframe, ul, ol, picture, svg');
  }

  function isEthicalStatementNode(node) {
    if (!node || (node.nodeType !== 1 && node.nodeType !== 3)) return false;
    var text = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!text || text.length > 420) return false;
    return text.indexOf('by purchasing this garment') !== -1 &&
      text.indexOf('supporting ethical fashion practices') !== -1 &&
      text.indexOf('fair wages') !== -1;
  }

  function isImageOnlyNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (!node.querySelector('img, picture, svg')) return false;
    var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length < 30;
  }

  function putFragment(target, fragment, options) {
    if (!target || !fragment || !fragmentHasContent(fragment)) return false;
    options = options || {};
    if (options.clear !== false) target.innerHTML = '';
    while (fragment.firstChild) target.appendChild(fragment.firstChild);
    target.hidden = false;
    return true;
  }

  function cloneChildren(from, to) {
    if (!from || !to) return;
    Array.prototype.slice.call(from.childNodes).forEach(function (node) {
      to.appendChild(node.cloneNode(true));
    });
  }

  function normalizeProductName(value) {
    return (value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[“”"']/g, '')
      .replace(/[\u2010\u2011\u2012\u2013\u2014\u2212]/g, '-')
      .replace(/[^a-zA-Z0-9&+\- ]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function productHandleFromUrl(url) {
    if (!url) return '';
    var match = String(url).match(/\/products\/([^?#/]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function extractWearEntries(fragment) {
    if (!fragmentHasContent(fragment)) return [];

    var entries = [];
    var seen = {};

    function add(name, url) {
      name = (name || '').replace(/^[\s•·⋅\-–—*]+/, '').replace(/\s+/g, ' ').trim();
      if (!name) return;
      var key = normalizeProductName(name);
      if (!key || seen[key]) return;
      seen[key] = true;
      entries.push({ name: name, url: url || '' });
    }

    fragment.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      add(link.textContent, link.getAttribute('href'));
    });

    var clone = fragment.cloneNode(true);
    clone.querySelectorAll('br').forEach(function (br) {
      br.parentNode.replaceChild(document.createTextNode('\n'), br);
    });
    clone.querySelectorAll('p, li, div, h1, h2, h3, h4, h5, h6').forEach(function (node) {
      node.appendChild(document.createTextNode('\n'));
    });

    (clone.textContent || '').split(/\n+/).forEach(function (line) {
      add(line, '');
    });

    return entries;
  }

  function getShopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch(getShopRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).catch(function () { return null; });
  }

  function searchProductByName(name) {
    var query = [
      'q=' + encodeURIComponent(name),
      'resources[type]=product',
      'resources[limit]=10',
      'resources[options][unavailable_products]=show',
      'resources[options][fields]=title'
    ].join('&');

    return fetch(getShopRoot() + 'search/suggest.json?' + query, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (payload) {
        var products = payload && payload.resources && payload.resources.results
          ? payload.resources.results.products || []
          : [];
        if (!products.length) return null;

        var wanted = normalizeProductName(name);
        var exact = products.find(function (candidate) {
          return normalizeProductName(candidate.title) === wanted;
        });
        var close = exact || products.find(function (candidate) {
          var candidateName = normalizeProductName(candidate.title);
          return candidateName.indexOf(wanted) !== -1 || wanted.indexOf(candidateName) !== -1;
        });
        if (!close) return null;

        return fetchProductByHandle(close.handle || productHandleFromUrl(close.url));
      })
      .catch(function () { return null; });
  }

  function resolveWearEntry(entry) {
    var handle = productHandleFromUrl(entry.url);
    if (handle) {
      return fetchProductByHandle(handle).then(function (product) {
        return product || searchProductByName(entry.name);
      });
    }
    return searchProductByName(entry.name);
  }

  function formatWearPrice(value) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      var formatted = theme.Currency.formatMoney(value, theme.moneyFormat);

      // Some Shopify money formats include HTML such as
      // <span class=money>$179.00</span>. These cards are built in JS, so return
      // only the visible price text instead of printing the markup literally.
      var decoder = document.createElement('div');
      decoder.innerHTML = formatted;
      return (decoder.textContent || decoder.innerText || formatted).trim();
    }
    var amount = (parseInt(value, 10) || 0) / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function createWearProductCard(product) {
    if (!product) return null;

    var article = document.createElement('article');
    article.className = 'bambi-editorial-product__pairing';

    var imageLink = document.createElement('a');
    imageLink.className = 'bambi-editorial-product__pairing-image';
    imageLink.href = product.url || (getShopRoot() + 'products/' + product.handle);

    if (product.featured_image) {
      var image = document.createElement('img');
      image.src = product.featured_image;
      image.alt = product.title || '';
      image.loading = 'lazy';
      imageLink.appendChild(image);
    }

    var meta = document.createElement('div');
    meta.className = 'bambi-editorial-product__pairing-meta';

    var titleLink = document.createElement('a');
    titleLink.href = imageLink.href;
    var title = document.createElement('h3');
    title.textContent = product.title || '';
    titleLink.appendChild(title);

    var price = document.createElement('span');
    price.textContent = formatWearPrice(product.price_min != null ? product.price_min : product.price);

    meta.appendChild(titleLink);
    meta.appendChild(price);
    article.appendChild(imageLink);
    article.appendChild(meta);
    return article;
  }

  function populateWearSliderFromDescription(info, fragment) {
    var root = info && info.closest ? info.closest('.bambi-editorial-product') : null;
    var slider = root ? root.querySelector('[data-bambi-wear-slider]') : null;
    var track = slider ? slider.querySelector('[data-bambi-wear-track]') : null;
    if (!slider || !track || !fragmentHasContent(fragment)) return false;

    // Liquid-rendered metafield/manual cards stay authoritative if present.
    if (track.querySelector('.bambi-editorial-product__pairing')) {
      slider.hidden = false;
      return true;
    }

    var entries = extractWearEntries(fragment);
    if (!entries.length) return false;

    slider.setAttribute('data-bambi-wear-loading', 'true');

    Promise.all(entries.map(resolveWearEntry)).then(function (products) {
      var currentProductId = root.getAttribute('data-product-id');
      var added = {};

      products.forEach(function (product) {
        if (!product || String(product.id) === String(currentProductId) || added[product.id]) return;
        var card = createWearProductCard(product);
        if (!card) return;
        added[product.id] = true;
        track.appendChild(card);
      });

      slider.removeAttribute('data-bambi-wear-loading');
      if (track.querySelector('.bambi-editorial-product__pairing')) {
        slider.hidden = false;
        slider.dispatchEvent(new CustomEvent('bambi:wear-updated'));
      }
    });

    return true;
  }

  function buildWearBlock(fragment) {
    if (!fragmentHasContent(fragment)) return null;
    var block = document.createElement('div');
    block.className = 'bambi-wear-block';

    var title = document.createElement('p');
    title.className = 'bambi-wear-block__title';
    title.textContent = 'Wear it with…';
    block.appendChild(title);
    cloneChildren(fragment, block);
    return block;
  }

  function initProductInfo(scope) {
    (scope || document).querySelectorAll('[data-bambi-product-info]').forEach(function (info) {
      if (info.getAttribute('data-bambi-product-info-ready') === 'true') return;

      var source = info.querySelector('[data-bambi-product-description-source]');
      if (!source) return;

      var buckets = {
        editorial: document.createElement('div'),
        description: document.createElement('div'),
        details: document.createElement('div'),
        size: document.createElement('div'),
        fabric: document.createElement('div'),
        preorder: document.createElement('div'),
        shipping: document.createElement('div'),
        wear: document.createElement('div'),
        ethical: document.createElement('div')
      };

      var current = 'editorial';
      var captureBow = false;

      Array.prototype.slice.call(source.childNodes).forEach(function (node) {
        if (node.nodeType === 3 && !node.textContent.trim()) return;

        if (isEthicalStatementNode(node)) {
          buckets.ethical.appendChild(node.cloneNode(true));
          captureBow = true;
          return;
        }

        if (captureBow && isImageOnlyNode(node)) {
          buckets.ethical.appendChild(node.cloneNode(true));
          captureBow = false;
          return;
        }

        if (captureBow && node.nodeType === 1 && (node.textContent || '').trim()) {
          captureBow = false;
        }

        current = distributeNode(node, buckets, current);
      });

      Object.keys(buckets).forEach(function (key) { trimBucket(buckets[key]); });

      // Romantic/story copy stays visible on the page rather than hiding inside
      // Product details. This includes title copy, styling prose, free-shipping
      // lines and AfterPay copy that were part of the original description.
      var editorialTarget = info.querySelector('[data-bambi-product-editorial]');
      putFragment(editorialTarget, buckets.editorial);

      // A standalone DESCRIPTION section is rendered permanently on the editorial
      // product template. On the default template it falls back into Product details
      // so older product pages keep their existing behaviour.
      var visibleDescription = info.querySelector('[data-bambi-product-description-visible]');
      if (visibleDescription) {
        if (putFragment(visibleDescription, buckets.description)) {
          var descriptionBlock = info.querySelector('[data-bambi-product-description-block]');
          if (descriptionBlock) descriptionBlock.hidden = false;
        }
      } else if (fragmentHasContent(buckets.description)) {
        while (buckets.description.lastChild) {
          buckets.details.insertBefore(buckets.description.lastChild, buckets.details.firstChild);
        }
      }

      // Product details is deliberately only the actual DETAILS section / bullet
      // list, never the whole description.
      var detailsPanel = info.querySelector('[data-bambi-accordion-panel="details"]');
      if (!putFragment(detailsPanel, buckets.details)) {
        var detailsAccordion = info.querySelector('[data-bambi-accordion="details"]');
        if (detailsAccordion) detailsAccordion.hidden = true;
      }

      var sizePanel = info.querySelector('[data-bambi-accordion-panel="size"]');
      if (fragmentHasContent(buckets.size)) putFragment(sizePanel, buckets.size);

      var fabricPanel = info.querySelector('[data-bambi-accordion-panel="fabric"]');
      if (fragmentHasContent(buckets.fabric)) putFragment(fabricPanel, buckets.fabric);

      var preorderDynamic = info.querySelector('[data-bambi-preorder-dynamic]');
      if (fragmentHasContent(buckets.preorder)) putFragment(preorderDynamic, buckets.preorder);

      var shippingDynamic = info.querySelector('[data-bambi-shipping-dynamic]');
      if (fragmentHasContent(buckets.shipping)) putFragment(shippingDynamic, buckets.shipping);

      // On the editorial template, WEAR IT WITH is converted into a real product
      // slider below the gallery. The product names can simply be typed one per line
      // in the Shopify product description; no metafield setup is required.
      if (fragmentHasContent(buckets.wear)) {
        var usedEditorialSlider = populateWearSliderFromDescription(info, buckets.wear);

        // Keep the old inline behaviour only for templates without the editorial
        // Wear It With slider, so legacy/default product pages are unaffected.
        if (!usedEditorialSlider) {
          var visibleWear = info.querySelector('[data-bambi-product-wear]');
          var wearBlock = buildWearBlock(buckets.wear);
          if (visibleWear && wearBlock) {
            visibleWear.innerHTML = '';
            visibleWear.appendChild(wearBlock);
            visibleWear.hidden = false;
          }

          var preorderWear = info.querySelector('[data-bambi-preorder-wear]');
          var preorderWearBlock = buildWearBlock(buckets.wear);
          if (preorderWear && preorderWearBlock) {
            preorderWear.innerHTML = '';
            preorderWear.appendChild(preorderWearBlock);
            preorderWear.hidden = false;
          }
        }
      }

      // Any legacy ethical-fashion message in the Shopify description is stripped
      // from the parsed content. v5 renders one permanent closing note directly
      // in Liquid below the product area, so it can never fall into an accordion.
      // (The ethical bucket is intentionally not rendered here.)

      info.setAttribute('data-bambi-product-info-ready', 'true');
    });
  }

  function initSizeChartButtons(scope) {
    (scope || document).querySelectorAll('[data-bambi-open-size-chart]').forEach(function (button) {
      if (button.getAttribute('data-bambi-size-chart-ready') === 'true') return;
      button.setAttribute('data-bambi-size-chart-ready', 'true');

      button.addEventListener('click', function () {
        var product = button.closest('.product-template__container') || document;
        var accordion = product.querySelector('[data-bambi-accordion="size"]');
        if (!accordion) return;
        accordion.open = true;
        accordion.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  }

  function initWearItWithSliders(scope) {
    (scope || document).querySelectorAll('[data-bambi-wear-slider]').forEach(function (slider) {
      if (slider.getAttribute('data-bambi-wear-ready') === 'true') return;

      var track = slider.querySelector('[data-bambi-wear-track]');
      var prev = slider.querySelector('[data-bambi-wear-prev]');
      var next = slider.querySelector('[data-bambi-wear-next]');
      if (!track || !prev || !next) return;

      slider.setAttribute('data-bambi-wear-ready', 'true');

      function stepSize() {
        var card = track.querySelector('.bambi-editorial-product__pairing');
        if (!card) return Math.max(track.clientWidth * 0.8, 240);
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function syncControls() {
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var hasOverflow = maxScroll > 4;
        prev.hidden = !hasOverflow;
        next.hidden = !hasOverflow;
        prev.disabled = !hasOverflow || track.scrollLeft <= 4;
        next.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 4;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -stepSize(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: stepSize(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', syncControls, { passive: true });
      slider.addEventListener('bambi:wear-updated', syncControls);
      window.addEventListener('resize', syncControls);
      syncControls();
    });
  }

  function init(scope) {
    initProductInfo(scope || document);
    initSizeChartButtons(scope || document);
    initWearItWithSliders(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();


/* Bambi collection Quick Add */
(function () {
  'use strict';

  function cartRoutes() {
    var node = document.querySelector('[data-cart-routes]');
    if (!node) return { cartUrl: '/cart', cartAddUrl: '/cart/add' };
    try { return JSON.parse(node.textContent); }
    catch (e) { return { cartUrl: '/cart', cartAddUrl: '/cart/add' }; }
  }

  function refreshCartCount() {
    var routes = cartRoutes();
    return fetch(routes.cartUrl + '.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var count = document.querySelector('[data-cart-count]');
        var bubble = document.querySelector('[data-cart-count-bubble]');
        var popupCount = document.querySelector('[data-cart-popup-cart-quantity]');
        if (count) count.textContent = cart.item_count;
        if (popupCount) popupCount.textContent = cart.item_count;
        if (bubble) {
          if (cart.item_count > 0) bubble.classList.remove('hide');
          else bubble.classList.add('hide');
        }
        return cart;
      });
  }

  function addVariant(quickAdd, variantId, sourceButton) {
    if (!quickAdd || !variantId || quickAdd.classList.contains('is-loading')) return;

    var label = quickAdd.querySelector('[data-bambi-quick-add-label]');
    var status = quickAdd.querySelector('[data-bambi-quick-add-status]');
    var routes = cartRoutes();
    var originalLabel = label ? label.textContent : 'Quick Add';

    quickAdd.classList.add('is-loading');
    if (sourceButton) sourceButton.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';
    if (status) status.textContent = 'Adding item to cart';

    fetch(routes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: 'id=' + encodeURIComponent(variantId) + '&quantity=1'
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || (json.status && json.status !== 200)) {
            throw new Error(json.description || 'Unable to add this item.');
          }
          return json;
        });
      })
      .then(function () { return refreshCartCount(); })
      .then(function () {
        quickAdd.classList.remove('is-loading');
        quickAdd.classList.remove('is-open');
        if (sourceButton) sourceButton.removeAttribute('aria-busy');
        if (label) {
          label.textContent = 'Added ✓';
          label.closest('.bambi-quick-add__trigger').classList.add('is-added');
        }
        if (status) status.textContent = 'Added to cart';

        window.setTimeout(function () {
          if (label) {
            label.textContent = originalLabel;
            label.closest('.bambi-quick-add__trigger').classList.remove('is-added');
          }
          if (status) status.textContent = '';
        }, 1600);
      })
      .catch(function (error) {
        quickAdd.classList.remove('is-loading');
        if (sourceButton) sourceButton.removeAttribute('aria-busy');
        if (label) label.textContent = 'Try again';
        if (status) status.textContent = error.message || 'Unable to add item to cart';
        window.setTimeout(function () {
          if (label) label.textContent = originalLabel;
        }, 1800);
      });
  }

  function initQuickAdd(scope) {
    (scope || document).querySelectorAll('[data-bambi-quick-add]').forEach(function (quickAdd) {
      if (quickAdd.getAttribute('data-bambi-quick-add-ready') === 'true') return;
      quickAdd.setAttribute('data-bambi-quick-add-ready', 'true');

      var trigger = quickAdd.querySelector('[data-bambi-quick-add-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var directVariant = trigger.getAttribute('data-bambi-quick-add-variant');
        if (directVariant) {
          addVariant(quickAdd, directVariant, trigger);
          return;
        }

        var isOpen = quickAdd.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      quickAdd.querySelectorAll('[data-bambi-quick-add-variant]').forEach(function (button) {
        if (button === trigger) return;
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          addVariant(quickAdd, button.getAttribute('data-bambi-quick-add-variant'), button);
        });
      });
    });
  }

  function closeQuickAdds(event) {
    document.querySelectorAll('[data-bambi-quick-add].is-open').forEach(function (quickAdd) {
      if (quickAdd.contains(event.target)) return;
      quickAdd.classList.remove('is-open');
      var trigger = quickAdd.querySelector('[data-bambi-quick-add-trigger]');
      if (trigger && trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
    });
  }



  function initBambiSignupPopup() {
    var popup = document.querySelector('[data-bambi-signup-popup]');
    if (!popup || popup.getAttribute('data-bambi-popup-ready') === 'true') return;
    popup.setAttribute('data-bambi-popup-ready', 'true');

    var success = popup.querySelector('[data-bambi-popup-success]');
    var form = popup.querySelector('#BambiPopupNewsletterForm');
    var formFields = popup.querySelector('[data-bambi-popup-form-fields]');
    var reminder = document.querySelector('[data-bambi-popup-reminder]');
    var reminderTrigger = reminder ? reminder.querySelector('[data-bambi-popup-reminder-trigger]') : null;
    var reminderClose = reminder ? reminder.querySelector('[data-bambi-popup-reminder-close]') : null;
    var delay = parseInt(popup.getAttribute('data-delay') || '5000', 10);
    var dismissDays = parseInt(popup.getAttribute('data-dismiss-days') || '7', 10);
    /* v6: use a fresh storage namespace so prior testing cannot suppress this build. */
    var storageKey = 'bambiNewsletterPopupDismissedUntilV6';
    var subscribedKey = 'bambiNewsletterPopupSubscribedV6';
    var reminderHiddenSessionKey = 'bambiNewsletterReminderHiddenSessionV1';
    var timer;
    var lastFocused;

    var inThemeEditor = !!(window.Shopify && window.Shopify.designMode);
    var inUnpublishedPreview = !!(
      window.Shopify &&
      window.Shopify.theme &&
      window.Shopify.theme.role &&
      window.Shopify.theme.role !== 'main'
    );
    var testingTheme = inThemeEditor || inUnpublishedPreview;

    function storageGet(key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    }

    function storageSet(key, value) {
      try { window.localStorage.setItem(key, value); } catch (e) {}
    }

    function sessionGet(key) {
      try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
    }

    function sessionSet(key, value) {
      try { window.sessionStorage.setItem(key, value); } catch (e) {}
    }

    function cleanContactFeedbackUrl() {
      try {
        var url = new URL(window.location.href);
        var changed = false;
        if (url.searchParams.has('contact_posted')) {
          url.searchParams.delete('contact_posted');
          changed = true;
        }
        if (url.hash === '#contact_form') {
          url.hash = '';
          changed = true;
        }
        if (changed && window.history && window.history.replaceState) {
          window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
        }
      } catch (e) {}
    }

    if (form && form.getAttribute('data-bambi-source-bound') !== 'true') {
      form.setAttribute('data-bambi-source-bound', 'true');
      form.addEventListener('submit', function () {
        sessionSet('bambiSignupSource', 'newsletter');
      });
    }

    function showReminder() {
      if (!reminder || storageGet(subscribedKey) === 'true' || sessionGet(reminderHiddenSessionKey) === 'true') return;
      reminder.hidden = false;
      window.requestAnimationFrame(function () { reminder.classList.add('is-visible'); });
    }

    function hideReminder() {
      if (!reminder) return;
      reminder.classList.remove('is-visible');
      reminder.hidden = true;
    }

    function openPopup() {
      lastFocused = document.activeElement;
      hideReminder();
      popup.hidden = false;
      document.body.classList.add('bambi-popup-open');
      window.requestAnimationFrame(function () {
        popup.classList.add('is-visible');
        /* Avoid stealing focus constantly while editing the theme. */
        var email = popup.querySelector('input[type="email"]');
        if (email && window.innerWidth > 749 && !inThemeEditor) email.focus();
      });
    }

    function closePopup(remember) {
      popup.classList.remove('is-visible');
      document.body.classList.remove('bambi-popup-open');
      popup.hidden = true;
      /* Never remember dismissals during Customize / unpublished preview. */
      if (remember !== false && !testingTheme) {
        var until = Date.now() + (dismissDays * 24 * 60 * 60 * 1000);
        storageSet(storageKey, String(until));
      }
      showReminder();
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    popup.querySelectorAll('[data-bambi-popup-close]').forEach(function (button) {
      button.addEventListener('click', function () { closePopup(true); });
    });

    if (reminder && reminder.getAttribute('data-bambi-reminder-ready') !== 'true') {
      reminder.setAttribute('data-bambi-reminder-ready', 'true');
      if (reminderTrigger) {
        reminderTrigger.addEventListener('click', function () {
          window.clearTimeout(timer);
          openPopup();
        });
      }
      if (reminderClose) {
        reminderClose.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          sessionSet(reminderHiddenSessionKey, 'true');
          hideReminder();
        });
      }
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) closePopup(true);
    });

    /* Clicking/selecting the popup section in Shopify Customize should always reveal it. */
    document.addEventListener('shopify:section:select', function (event) {
      if (!event || !event.target) return;
      if (event.target === popup || (event.target.contains && event.target.contains(popup))) {
        window.clearTimeout(timer);
        openPopup();
      }
    });

    var formError = popup.querySelector('[data-bambi-popup-error]');
    var feedbackSource = sessionGet('bambiSignupSource');

    if (success) {
      if (feedbackSource === 'newsletter' || !feedbackSource) {
        if (formFields) formFields.hidden = true;
        success.hidden = false;
        if (formError) formError.hidden = true;
        if (!testingTheme) storageSet(subscribedKey, 'true');
        hideReminder();
        cleanContactFeedbackUrl();
        window.setTimeout(openPopup, 150);
      } else {
        success.hidden = true;
        if (formFields) formFields.hidden = false;
        if (formError) formError.hidden = true;
      }
      return;
    }

    if (formError) {
      if (feedbackSource === 'newsletter' || !feedbackSource) {
        formError.hidden = false;
        window.setTimeout(openPopup, 150);
      } else {
        formError.hidden = true;
      }
      return;
    }

    /* In Customize and unpublished preview, always show immediately for easy editing/testing. */
    if (testingTheme) {
      window.setTimeout(openPopup, inThemeEditor ? 100 : 500);
      return;
    }

    if (storageGet(subscribedKey) === 'true') {
      hideReminder();
      return;
    }
    var dismissedUntil = parseInt(storageGet(storageKey) || '0', 10);
    if (dismissedUntil && Date.now() < dismissedUntil) {
      showReminder();
      return;
    }

    hideReminder();
    timer = window.setTimeout(openPopup, Math.max(0, delay));
    window.addEventListener('beforeunload', function () { window.clearTimeout(timer); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initQuickAdd(document); initBambiSignupPopup(); });
  } else {
    initQuickAdd(document);
    initBambiSignupPopup();
  }

  document.addEventListener('click', closeQuickAdds);
  document.addEventListener('shopify:section:load', function (event) { initQuickAdd(event.target); initBambiSignupPopup(); });
})();


/* Bambi central branding sync */
(function () {
  function syncBambiBranding() {
    var control = document.querySelector('[data-bambi-branding-control]');
    if (!control) return;

    var logoUrl = control.getAttribute('data-logo-url');
    var logoAlt = control.getAttribute('data-logo-alt') || 'Bambi The Label';
    var headerWidth = control.getAttribute('data-header-logo-width');
    var popupWidth = control.getAttribute('data-popup-logo-width');

    document.querySelectorAll('[data-bambi-brand-logo-target]').forEach(function (img) {
      if (logoUrl) img.src = logoUrl;
      img.alt = logoAlt;
    });

    document.querySelectorAll('.site-header__logo-image').forEach(function (logo) {
      if (headerWidth) logo.style.maxWidth = headerWidth + 'px';
    });

    document.querySelectorAll('.bambi-signup-popup__brand-logo').forEach(function (logo) {
      if (popupWidth) logo.style.width = popupWidth + 'px';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncBambiBranding);
  } else {
    syncBambiBranding();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target && event.target.querySelector && event.target.querySelector('[data-bambi-branding-control]')) {
      syncBambiBranding();
    }
  });
  document.addEventListener('shopify:section:select', syncBambiBranding);
})();


/* Upcoming Collection signup popup — opens from the homepage editorial card. */
(function () {
  var lastFocused = null;

  function getPopup() {
    return document.querySelector('[data-bambi-collection-popup]');
  }

  function sessionGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function sessionSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) {}
  }

  function cleanContactFeedbackUrl() {
    try {
      var url = new URL(window.location.href);
      var changed = false;
      if (url.searchParams.has('contact_posted')) {
        url.searchParams.delete('contact_posted');
        changed = true;
      }
      if (url.hash === '#contact_form') {
        url.hash = '';
        changed = true;
      }
      if (changed && window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
      }
    } catch (e) {}
  }

  function prepareCollectionFormFeedback() {
    var popup = getPopup();
    if (!popup) return;

    var form = popup.querySelector('#BambiCollectionSignupForm');
    var fields = popup.querySelector('[data-bambi-collection-popup-form-fields]');
    var success = popup.querySelector('[data-bambi-collection-popup-success]');
    var error = popup.querySelector('[data-bambi-collection-popup-error]');
    var source = sessionGet('bambiSignupSource');

    if (form && form.getAttribute('data-bambi-source-bound') !== 'true') {
      form.setAttribute('data-bambi-source-bound', 'true');
      form.addEventListener('submit', function () {
        sessionSet('bambiSignupSource', 'collection');
      });
    }

    if (success) {
      if (source === 'collection') {
        if (fields) fields.hidden = true;
        success.hidden = false;
        if (error) error.hidden = true;
        cleanContactFeedbackUrl();
      } else {
        success.hidden = true;
        if (fields) fields.hidden = false;
        if (error) error.hidden = true;
      }
      return;
    }

    if (error) {
      if (source === 'collection') {
        error.hidden = false;
      } else {
        error.hidden = true;
      }
    }
  }

  function openCollectionPopup() {
    var popup = getPopup();
    if (!popup) return false;

    lastFocused = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('bambi-popup-open');

    window.requestAnimationFrame(function () {
      popup.classList.add('is-visible');
      var email = popup.querySelector('input[type="email"]');
      var inThemeEditor = !!(window.Shopify && window.Shopify.designMode);
      if (email && window.innerWidth > 749 && !inThemeEditor) email.focus();
    });

    return true;
  }

  function closeCollectionPopup() {
    var popup = getPopup();
    if (!popup) return;

    popup.classList.remove('is-visible');
    document.body.classList.remove('bambi-popup-open');
    popup.hidden = true;

    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest('[data-bambi-collection-popup-trigger], a[href="#upcoming-collection"], a[href$="#upcoming-collection"]');
    if (trigger) {
      /* If the popup is disabled/absent, leave the anchor alone as a graceful fallback. */
      if (getPopup()) {
        event.preventDefault();
        openCollectionPopup();
      }
      return;
    }

    var close = target.closest('[data-bambi-collection-popup-close]');
    if (close && getPopup() && getPopup().contains(close)) {
      event.preventDefault();
      closeCollectionPopup();
    }
  });

  document.addEventListener('keydown', function (event) {
    var popup = getPopup();
    if (event.key === 'Escape' && popup && !popup.hidden) closeCollectionPopup();
  });

  function openForFormFeedback() {
    var popup = getPopup();
    if (!popup) return;
    var source = sessionGet('bambiSignupSource');
    if (source !== 'collection') return;
    if (popup.querySelector('[data-bambi-collection-popup-success]') || popup.querySelector('[data-bambi-collection-popup-error]')) {
      window.setTimeout(openCollectionPopup, 150);
    }
  }

  function openFromCollectionHash() {
    if (window.location.hash === '#upcoming-collection') {
      window.setTimeout(openCollectionPopup, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      prepareCollectionFormFeedback();
      openForFormFeedback();
      openFromCollectionHash();
    });
  } else {
    prepareCollectionFormFeedback();
    openForFormFeedback();
    openFromCollectionHash();
  }

  window.addEventListener('hashchange', openFromCollectionHash);

  /* Selecting the popup in Shopify Customize reveals it for editing. */
  document.addEventListener('shopify:section:select', function (event) {
    var popup = getPopup();
    if (!popup || !event || !event.target) return;
    if (event.target === popup || (event.target.contains && event.target.contains(popup))) {
      openCollectionPopup();
    }
  });

  document.addEventListener('shopify:section:load', function () {
    prepareCollectionFormFeedback();
    openForFormFeedback();
  });
})();


/* Bambi conversion trust — variant-aware delivery reassurance. */
(function () {
  function normalize(value) {
    return String(value || '').toLowerCase().replace(/[\u2010-\u2015]/g, '-');
  }

  function isPreorderTitle(value) {
    var title = normalize(value);
    return title.indexOf('pre-order') !== -1 || title.indexOf('preorder') !== -1 || title.indexOf('pre order') !== -1;
  }

  function getProductRoot(node) {
    if (!node || !node.closest) return null;
    return node.closest('[data-section-type="product"]');
  }

  function getProductData(root) {
    if (!root) return null;
    var sectionId = root.getAttribute('data-section-id');
    var el = sectionId ? document.getElementById('ProductJson-' + sectionId) : null;
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function selectedVariant(root, suppliedVariant) {
    if (suppliedVariant && suppliedVariant.id) return suppliedVariant;
    var product = getProductData(root);
    if (!product || !product.variants) return null;
    var master = root.querySelector('select[name="id"], .product-form__variants');
    var id = master ? String(master.value) : '';
    for (var i = 0; i < product.variants.length; i += 1) {
      if (String(product.variants[i].id) === id) return product.variants[i];
    }
    return product.variants[0] || null;
  }

  function addToCartSaysPreorder(root) {
    if (!root) return false;
    var buttonText = root.querySelector('[data-add-to-cart-text]');
    var button = root.querySelector('[data-add-to-cart]');
    var text = buttonText ? buttonText.textContent : (button ? button.textContent : '');
    return isPreorderTitle(text);
  }

  function updateConfidence(root, suppliedVariant) {
    if (!root) return;
    var block = root.querySelector('[data-bambi-purchase-confidence]');
    if (!block) return;

    var variant = selectedVariant(root, suppliedVariant);
    if (!variant) return;

    var title = block.querySelector('[data-bambi-status-title]');
    var copy = block.querySelector('[data-bambi-status-copy]');
    var status = block.querySelector('[data-bambi-purchase-status]');
    if (!title || !copy || !status) return;

    var productTaggedPreorder = block.getAttribute('data-preorder-product-tag') === 'true';
    var hasVariantLabels = block.getAttribute('data-has-variant-preorder-labels') === 'true';

    /* Some pre-order apps change the CTA after Shopify's variant event has
       already fired. Treat the app's visible PRE-ORDER button as the final
       source of truth so our reassurance message always matches the CTA. */
    var preorder = addToCartSaysPreorder(root) || isPreorderTitle(variant.title) || (productTaggedPreorder && !hasVariantLabels);

    status.classList.remove('is-instock', 'is-preorder', 'is-unavailable');
    if (!variant.available && !preorder) {
      status.classList.add('is-unavailable');
      title.textContent = 'Currently unavailable';
      copy.textContent = 'Choose another available size or check back soon.';
    } else if (preorder) {
      status.classList.add('is-preorder');
      title.textContent = 'Pre-order — secure your size';
      copy.textContent = block.getAttribute('data-preorder-copy') || 'This piece will dispatch as soon as it becomes available.';
    } else {
      status.classList.add('is-instock');
      title.textContent = 'In stock — ready to ship';
      copy.textContent = block.getAttribute('data-instock-copy') || 'Usually dispatches within 1–2 business days.';
    }
  }

  function bindRoot(root) {
    if (!root || root.getAttribute('data-bambi-confidence-bound') === 'true') return;
    root.setAttribute('data-bambi-confidence-bound', 'true');
    root.addEventListener('variantChange', function (event) {
      updateConfidence(root, event && event.detail ? event.detail.variant : null);
      /* Give third-party pre-order apps time to rewrite the CTA. */
      window.setTimeout(function () { updateConfidence(root); }, 60);
      window.setTimeout(function () { updateConfidence(root); }, 300);
    });

    /* Watch only the product form, not the reassurance block itself, so an app
       can change ADD TO BAG -> PRE-ORDER at any time without creating a
       MutationObserver feedback loop. */
    var form = root.querySelector('[data-product-form], form.product-form');
    if (form && window.MutationObserver) {
      var preorderObserver = new MutationObserver(function () {
        window.setTimeout(function () { updateConfidence(root); }, 0);
      });
      preorderObserver.observe(form, { childList: true, subtree: true, characterData: true });
    }

    updateConfidence(root);
    window.setTimeout(function () { updateConfidence(root); }, 300);
  }

  function init(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-section-type="product"]')) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      Array.prototype.push.apply(roots, scope.querySelectorAll('[data-section-type="product"]'));
    }
    roots.forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.closest) return;
    var root = getProductRoot(event.target);
    if (!root) return;
    window.setTimeout(function () { updateConfidence(root); }, 0);
  });
})();


/* Keep Route's utility product out of customer-facing predictive search. */
(function () {
  function hideRouteUtilityProducts(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('a[href*="/products/routeins"], a[href*="shipping-protection-by-route"]').forEach(function (link) {
      var card = link.closest('li, .predictive-search-item, .predictive-search__item, .product-card, [role="option"]');
      if (card) card.style.display = 'none';
    });

    scope.querySelectorAll('li, .predictive-search-item, .predictive-search__item, [role="option"]').forEach(function (item) {
      var text = (item.textContent || '').toLowerCase();
      if (text.indexOf('shipping protection by route') !== -1) item.style.display = 'none';
    });
  }

  function init() {
    hideRouteUtilityProducts(document);
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node && node.nodeType === 1) hideRouteUtilityProducts(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Bambi premium AJAX cart drawer. Keeps Debut's native add-to-cart hooks while
   rendering the actual cart as a richer, reusable mini-cart. */
(function () {
  var wrapper;
  var drawer;
  var itemsRoot;
  var emptyRoot;
  var footer;
  var countRoots;
  var subtotalRoot;
  var quantityRoot;
  var shippingRoot;
  var shippingTitleRoot;
  var shippingTextRoot;
  var shippingProgressRoot;
  var promoRoot;
  var promoForm;
  var promoInput;
  var promoStatus;
  var checkoutForm;
  var promoStorageKey = 'bambiPromoCode';
  var isUpdating = false;

  function money(cents, currency) {
    var value = (Number(cents || 0) / 100);
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'AUD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return (currency || 'AUD') + ' ' + value.toFixed(2);
    }
  }

  function clear(node) {
    while (node && node.firstChild) node.removeChild(node.firstChild);
  }

  function text(tag, className, value) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    node.textContent = value || '';
    return node;
  }

  function renderItem(item, currency) {
    var row = document.createElement('div');
    row.className = 'bambi-cart-drawer__item';

    var imageLink = document.createElement('a');
    imageLink.className = 'bambi-cart-drawer__item-image-link';
    imageLink.href = item.url || '/cart';

    var imageUrl = item.image || (item.featured_image && item.featured_image.url);
    if (imageUrl) {
      var image = document.createElement('img');
      image.className = 'bambi-cart-drawer__item-image';
      image.src = imageUrl;
      image.alt = (item.featured_image && item.featured_image.alt) || item.product_title || '';
      image.loading = 'lazy';
      imageLink.appendChild(image);
    }
    row.appendChild(imageLink);

    var copy = document.createElement('div');
    copy.className = 'bambi-cart-drawer__item-copy';

    var titleLink = document.createElement('a');
    titleLink.className = 'bambi-cart-drawer__item-title';
    titleLink.href = item.url || '/cart';
    titleLink.textContent = item.product_title || item.title || '';
    copy.appendChild(titleLink);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      copy.appendChild(text('span', 'bambi-cart-drawer__item-variant', item.variant_title));
    }
    copy.appendChild(text('span', 'bambi-cart-drawer__item-qty', 'Qty ' + (item.quantity || 1)));

    var removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'bambi-cart-drawer__item-remove';
    removeButton.setAttribute('data-bambi-cart-drawer-remove', '');
    removeButton.setAttribute('data-line-item-key', item.key || '');
    removeButton.setAttribute('aria-label', 'Remove ' + (item.product_title || item.title || 'item') + ' from bag');
    removeButton.textContent = 'Remove';
    copy.appendChild(removeButton);

    row.appendChild(copy);

    var linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
    row.appendChild(text('div', 'bambi-cart-drawer__item-price', money(linePrice, currency)));

    return row;
  }

  function syncHeaderCartCount(cart) {
    if (!cart) return;
    var count = document.querySelector('[data-cart-count]');
    var bubble = document.querySelector('[data-cart-count-bubble]');
    if (count) count.textContent = cart.item_count || '';
    if (bubble) {
      if (cart.item_count > 0) bubble.classList.remove('hide');
      else bubble.classList.add('hide');
    }
  }

  function update(cart) {
    if (!cart || !itemsRoot) return;
    syncHeaderCartCount(cart);
    clear(itemsRoot);

    var currency = cart.currency || 'AUD';
    var items = cart.items || [];
    items.forEach(function (item) {
      itemsRoot.appendChild(renderItem(item, currency));
    });

    if (emptyRoot) emptyRoot.hidden = items.length !== 0;
    if (footer) footer.hidden = items.length === 0;

    if (countRoots) {
      Array.prototype.forEach.call(countRoots, function (node) {
        node.textContent = '(' + (cart.item_count || 0) + ')';
      });
    }
    if (subtotalRoot) subtotalRoot.textContent = money(cart.total_price, currency);
    if (quantityRoot) quantityRoot.textContent = cart.item_count || 0;

    if (shippingRoot) {
      if (!items.length) {
        shippingRoot.hidden = true;
      } else {
        var normalizedCurrency = String(currency || 'AUD').toUpperCase();
        var freeShippingThreshold = normalizedCurrency === 'USD' ? 29000 : 40000;
        var shippingRemaining = Math.max(0, freeShippingThreshold - Number(cart.total_price || 0));
        var shippingProgress = Math.min(100, Math.max(0, (Number(cart.total_price || 0) / freeShippingThreshold) * 100));

        shippingRoot.hidden = false;
        shippingRoot.classList.toggle('bambi-cart-drawer__shipping--unlocked', shippingRemaining === 0);

        if (shippingTitleRoot) {
          shippingTitleRoot.textContent = shippingRemaining === 0
            ? '✓ You’ve unlocked Free Shipping'
            : 'You’re ' + money(shippingRemaining, normalizedCurrency) + ' away from Free Shipping';
        }
        if (shippingTextRoot) {
          shippingTextRoot.textContent = 'Free Shipping over $290 USD / $400 AUD.';
        }
        if (shippingProgressRoot) {
          shippingProgressRoot.style.width = shippingProgress + '%';
        }
      }
    }
  }

  function getPromoCode() {
    try {
      return (window.sessionStorage && sessionStorage.getItem(promoStorageKey)) || '';
    } catch (e) {
      return '';
    }
  }

  function savePromoCode(code) {
    try {
      if (!window.sessionStorage) return;
      if (code) sessionStorage.setItem(promoStorageKey, code);
      else sessionStorage.removeItem(promoStorageKey);
    } catch (e) {}
  }

  function syncPromoUI() {
    if (!promoInput) return;
    var savedCode = getPromoCode();
    if (savedCode && !promoInput.value) promoInput.value = savedCode;
    if (promoStatus && savedCode) {
      promoStatus.textContent = '“' + savedCode + '” will be applied at checkout.';
      promoStatus.classList.add('bambi-cart-drawer__promo-status--saved');
    }
  }

  function checkoutWithPromo(event) {
    var code = getPromoCode();
    if (!code) return;

    event.preventDefault();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'checkout');
  }

  function removeLineItem(key, button) {
    if (!key || isUpdating) return;
    isUpdating = true;

    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'Removing…';
    }

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to remove item');
        return response.json();
      })
      .then(function (cart) {
        update(cart);
      })
      .catch(function () {
        if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.textContent = 'Remove';
        }
      })
      .then(function () { isUpdating = false; });
  }

  function fetchCart(callback) {
    if (isUpdating) return;
    isUpdating = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        update(cart);
        if (callback) callback(cart);
      })
      .catch(function () {})
      .then(function () { isUpdating = false; });
  }

  function show() {
    if (!wrapper) return;
    syncPromoUI();
    wrapper.classList.remove('cart-popup-wrapper--hidden');
    document.body.classList.add('bambi-cart-drawer-open');
    if (drawer && drawer.focus) window.setTimeout(function () { drawer.focus(); }, 30);
  }

  function hide() {
    if (!wrapper) return;
    wrapper.classList.add('cart-popup-wrapper--hidden');
    document.body.classList.remove('bambi-cart-drawer-open');
  }

  function init() {
    wrapper = document.querySelector('[data-cart-popup-wrapper]');
    if (!wrapper || wrapper.getAttribute('data-bambi-cart-drawer-bound') === 'true') return;
    wrapper.setAttribute('data-bambi-cart-drawer-bound', 'true');

    drawer = wrapper.querySelector('[data-cart-popup]');
    itemsRoot = wrapper.querySelector('[data-bambi-cart-drawer-items]');
    emptyRoot = wrapper.querySelector('[data-bambi-cart-drawer-empty]');
    footer = wrapper.querySelector('[data-bambi-cart-drawer-footer]');
    countRoots = wrapper.querySelectorAll('[data-bambi-cart-drawer-count]');
    subtotalRoot = wrapper.querySelector('[data-bambi-cart-drawer-subtotal]');
    quantityRoot = wrapper.querySelector('[data-bambi-cart-drawer-quantity]');
    shippingRoot = wrapper.querySelector('[data-bambi-cart-drawer-shipping]');
    shippingTitleRoot = wrapper.querySelector('[data-bambi-cart-drawer-shipping-title]');
    shippingTextRoot = wrapper.querySelector('[data-bambi-cart-drawer-shipping-text]');
    shippingProgressRoot = wrapper.querySelector('[data-bambi-cart-drawer-shipping-progress]');
    promoRoot = wrapper.querySelector('[data-bambi-cart-drawer-promo]');
    promoForm = wrapper.querySelector('[data-bambi-cart-drawer-promo-form]');
    promoInput = wrapper.querySelector('[data-bambi-cart-drawer-promo-input]');
    promoStatus = wrapper.querySelector('[data-bambi-cart-drawer-promo-status]');
    checkoutForm = wrapper.querySelector('[data-bambi-cart-drawer-checkout-form]');

    syncPromoUI();

    if (promoForm) {
      promoForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var code = promoInput ? promoInput.value.replace(/^\s+|\s+$/g, '') : '';
        if (!code) {
          savePromoCode('');
          if (promoStatus) {
            promoStatus.textContent = 'Enter a promo code first.';
            promoStatus.classList.remove('bambi-cart-drawer__promo-status--saved');
          }
          return;
        }
        savePromoCode(code);
        if (promoInput) promoInput.value = code;
        if (promoStatus) {
          promoStatus.textContent = '“' + code + '” will be applied at checkout.';
          promoStatus.classList.add('bambi-cart-drawer__promo-status--saved');
        }
      });
    }

    if (checkoutForm) checkoutForm.addEventListener('submit', checkoutWithPromo);

    document.addEventListener('click', function (event) {
      var removeButton = event.target.closest && event.target.closest('[data-bambi-cart-drawer-remove]');
      if (removeButton && wrapper && wrapper.contains(removeButton)) {
        event.preventDefault();
        removeLineItem(removeButton.getAttribute('data-line-item-key'), removeButton);
        return;
      }

      var cartLink = event.target.closest && event.target.closest('.site-header__cart');
      if (cartLink && wrapper) {
        event.preventDefault();
        fetchCart(function () { show(); });
        return;
      }

      if (event.target.closest && event.target.closest('[data-bambi-cart-drawer-backdrop]')) {
        hide();
        return;
      }

      if (event.target.closest && event.target.closest('[data-cart-popup-close], [data-cart-popup-dismiss]')) {
        hide();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !wrapper.classList.contains('cart-popup-wrapper--hidden')) hide();
    });

    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName !== 'class') return;
          if (wrapper.classList.contains('cart-popup-wrapper--hidden')) {
            document.body.classList.remove('bambi-cart-drawer-open');
          } else {
            document.body.classList.add('bambi-cart-drawer-open');
            fetchCart();
          }
        });
      });
      observer.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    }
  }

  window.BambiCartDrawer = { update: update, refresh: fetchCart, show: show, hide: hide };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
